export default {
  /*
  [MODAL.EXAMPLE]: {
    modalId: MODAL.EXAMPLE,
    ...data
  }
  */
};
